export default "__VITE_ASSET__dP7n871E__"